import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CountdownClockComponent } from '@finder/shared/components/countdown-clock/countdown-clock.component';
import { LottieBgComponent } from '@finder/shared/components/lottie-bg/lottie-bg.component';
import get from 'lodash-es/get';

@Component({
    selector: 'finder-campaign-countdown-clock',
    templateUrl: './campaign-countdown-clock.component.html',
    styleUrls: ['./campaign-countdown-clock.component.scss'],
    standalone: true,
    imports: [
        LottieBgComponent,
        CountdownClockComponent,
        CommonModule,
    ]
})
export class CampaignCountdownClockComponent implements OnInit {
    @Input() countdownClockData;
    @Input() target;
    @Output() triggerPlayback = new EventEmitter<boolean>();

    targetMatch: boolean;
    cssClass = '';

    constructor(
        private el: ElementRef,
    ) {}

    ngOnInit() {
        this.checkTarget();
    }

    clockVisible(event) {
        this.triggerPlayback.emit(event);
    }

    private checkTarget() {
        const targetData = get(this.countdownClockData, 'target');
        const positionData = get(this.countdownClockData, 'position', '');
        this.targetMatch = this.target === targetData;
        this.setCssClass(targetData, positionData);
    }

    private setCssClass(targetData, positionData) {
        // Check to see if we have a target and apply the target class name
        switch (targetData) {
            case 'hero':
                this.cssClass = 'hero-countdown-clock';
                break;
            case 'imageBlock':
                this.cssClass = 'image-block-countdown-clock';
                break;
        }

        // Append positioning class
        this.cssClass = `${this.cssClass} ${positionData}`.trim();

        // Lottie settings - we only need to proceed if we actaully have some bg items
        const bgItems = get(this.countdownClockData, 'bgItems', []);
        if (!bgItems.length) {
            return;
        }

        this.el.nativeElement.style.setProperty('--finder-lottie-player-display', 'block');
        this.el.nativeElement.style.setProperty('--finder-lottie-player-justify-content', 'initial');
        this.el.nativeElement.style.setProperty('--finder-lottie-player-position', 'absolute');
        this.el.nativeElement.style.setProperty('--finder-lottie-player-overflow', 'visible');
    }
}
